import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import StudioPage from "@/pages/studio/page";
import ContactPage from "@/pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/studio", element: <StudioPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;